/**
 * CMS 회원 리스트 모달 — $j.F.Admin.CmsMembers (정적 모듈)
 *
 * 마크업은 adm/pages/cms/members.blade.php. /adm/cms 의 [CMS 회원 리스트 보기/수정] 이 JBModal 로 불러오고
 * onOpen 에서 init() 을 부른다. CMS코드 수정·해제.
 */
export default class CmsMembers {
    static init() {
        var $table = $('#cms-member-table').DataTable({
            processing: true,
            serverSide: true,
            ordering: false,
            searching: false,
            pageLength: 20,
            lengthChange: false,
            ajax: {
                url: '/adm/ajax/cms/members/list',
                type: 'post',
                data: function(d){ d.kwd = $('#cms-search-kwd').val(); }
            },
            columns: [
                { data: 'mem_name', className: 'mem-name' },
                { data: 'num', render: function(d){ return $j.F.Admin.Member.Pop.cellNo(d); } },   // 옆 칸이 이름 — 번호만, 누르면 회원 팝오버
                { data: 'mem_phone' },
                { data: 'cms_num', render: function(d, t, row){
                    return `<input type="text" class="cms-code-input" value="${d||''}" data-num="${row.num}">`;
                }},
                { data: 'eacnt', render: function(d){ return d+'번출금'; } },
                { data: null, render: function(d, t, row){
                    return `<input type="button" value="수정" class="btn-cms btn-edit" data-num="${row.num}">
                            <input type="button" value="해제" class="btn-cms btn-release" data-num="${row.num}">`;
                }}
            ],
            language: {
                info: "총 _TOTAL_ 명 중 _START_ ~ _END_",
                infoEmpty: "데이터 없음",
                infoFiltered: "",
                emptyTable: "CMS 등록 회원이 없습니다.",
                processing: "로딩 중..."
            }
        });

        // 검색
        $('#cms-search-btn').on('click', function(){ $table.ajax.reload(); });
        $('#cms-search-kwd').on('keyup', function(e){ if(e.key === 'Enter') $table.ajax.reload(); });

        // 수정
        $('#cms-member-table').on('click', '.btn-edit', async function(){
            var $tr = $(this).closest('tr');
            var num = $(this).data('num');
            var cmscode = $tr.find('.cms-code-input').val().trim();
            var name = $tr.find('.mem-name').text();

            if(cmscode.length < 6){ $j.Ui.Toast.show('error', 'CMS코드 자리수를 확인해 주세요. 기본 10자리 숫자입니다.'); return; }
            if(!await $j.Ui.Dialog.confirm(`[${name}] 회원의 CMS코드를 수정할까요?`)) return;

            $.ajax({
                type: 'POST', url: '/adm/ajax/cms/members/edit',
                data: { usernum: num, newcmscode: cmscode }, dataType: 'json',
                success: function(data){
                    if(data.result) $j.Ui.Toast.show('success', '수정되었습니다');
                    else $j.Ui.Toast.show('error', data.reson || '수정 실패');
                }
            });
        });

        // 해제
        $('#cms-member-table').on('click', '.btn-release', async function(){
            var num = $(this).data('num');
            var name = $(this).closest('tr').find('.mem-name').text();
            var ok = await $j.Ui.Dialog.confirm(`[${name}] 회원의 CMS코드를 해제할까요?`, {
                desc: '해제 후 다음달부터 사용자 포인트에서 회비가 출금됩니다.'
            });
            if(!ok) return;

            $.ajax({
                type: 'POST', url: '/adm/ajax/cms/members/release',
                data: { usernum: num }, dataType: 'json',
                success: function(data){
                    if(data.result){ $j.Ui.Toast.show('success', 'CMS 설정이 해제되었습니다'); $table.ajax.reload(false); }
                    else $j.Ui.Toast.show('error', data.reson || '해제 실패');
                }
            });
        });

    }
}
